module.exports = __webpack_public_path__ + "static/media/req-workspace-seller-lawyer-help3.9f3eee41.svg";